import $http from '@/utils/fetch'

const lotteryPointsWinList = data => {
  return $http.post('lottery/win/list', data)
}

const lotteryAnnouncementList = data => {
  return $http.post('lottery/announcement/list', data)
}

const lotteryCouponList = data => {
  return $http.post('lottery/change/coupon/list', data)
}

const lotteryChangyouPointAuth = data => {
  return $http.post('changyouPoint/auth', data)
}

const lotteryChangyouPointSend = data => {
  return $http.post('changyouPoint/send/sms', data)
}

const lotteryChangyouPointBind = data => {
  return $http.post('changyouPoint/bind/sms', data)
}

const lotteryChangyouPointSendOrder = data => {
  return $http.post('changyouPoint/send/order', data)
}

const lotteryChangyouPointOrderPay = data => {
  return $http.post('changyouPoint/order/pay', data)
}

const lotteryChangyouPointActSend = data => {
  return $http.post('changyouPoint/act/send/sms', data)
}

const lotteryChangyouPointActBind = data => {
  return $http.post('changyouPoint/act/bind/sms', data)
}

const lotteryPointsOrderList = data => {
  return $http.post('user/lottery/points/order/list', data)
}

const lotteryPointsOrderInfo = data => {
  return $http.post('user/lottery/points/order/info', data)
}

const getProducts = data => {
  return $http.post('mall/product/list', data)
}

export default {
  lotteryPointsWinList,
  lotteryAnnouncementList,
  lotteryCouponList,
  lotteryChangyouPointAuth,
  lotteryChangyouPointSend,
  lotteryChangyouPointBind,
  lotteryChangyouPointSendOrder,
  lotteryChangyouPointOrderPay,
  lotteryChangyouPointActSend,
  lotteryChangyouPointActBind,
  lotteryPointsOrderList,
  lotteryPointsOrderInfo,
  getProducts
}
